export const OWNER_FILE_UPLOAD_REQUEST = "OWNER_FILE_UPLOAD_REQUEST";
export const OWNER_FILE_UPLOAD_SUCCESS = "OWNER_FILE_UPLOAD_SUCCESS";
export const OWNER_FILE_UPLOAD_FAILURE = "OWNER_FILE_UPLOAD_FAILURE";
